import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createGcpVpcIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M25.6 8.80006H14.4V11.6001H25.6V8.80006Z" fill="#669DF6"/>
    <path d="M25.6 28.3999H14.4V31.1999H25.6V28.3999Z" fill="#669DF6"/>
    <path d="M31.2 14.4H28.4V25.6H31.2V14.4Z" fill="#669DF6"/>
    <path d="M11.6 14.4H8.80002V25.6H11.6V14.4Z" fill="#669DF6"/>
    <path d="M11.6 14.4H8.80002V17.2H11.6V14.4Z" fill="#4285F4"/>
    <path d="M31.2 14.4H28.4V17.2H31.2V14.4Z" fill="#4285F4"/>
    <path d="M17.2 8.80006H14.4V11.6001H17.2V8.80006Z" fill="#669DF6"/>
    <path d="M17.2 28.3999H14.4V31.1999H17.2V28.3999Z" fill="#4285F4"/>
    <path d="M29.8 25.6001H25.6V34.0001H29.8V25.6001Z" fill="#AECBFA"/>
    <path d="M34 25.6001H29.8V34.0001H34V25.6001Z" fill="#669DF6"/>
    <path d="M14.4 25.6001H10.2V34.0001H14.4V31.1999V28.3999L14.4 25.6001Z" fill="#669DF6"/>
    <path d="M10.2 25.6001H6V34.0001H10.2V25.6001Z" fill="#AECBFA"/>
    <path d="M8.80002 14.4L10.2 14.4V6H6V14.4L8.80002 14.4Z" fill="#AECBFA"/>
    <path d="M11.6 14.4L14.4 14.4L14.4 11.6001V8.80006V6H10.2V14.4L11.6 14.4Z" fill="#669DF6"/>
    <path d="M28.4 14.4L29.8 14.4V6H25.6V14.4L28.4 14.4Z" fill="#AECBFA"/>
    <path d="M31.2 14.4L34 14.4V6H29.8V14.4L31.2 14.4Z" fill="#669DF6"/>
    <path d="M34 25.6005H31.1998V14.3995H34V6.00002H29.8003V4.72729H35.2728V15.6723H32.4725V24.3278H35.2728V35.2728H24.3278V32.4725H15.6723V35.2728H4.72729V24.3278H7.52754V15.6723H4.72729V4.72729H10.1998V6.00002H6.00002V14.3995H8.80027V25.6005H6.00002V34H14.3995V31.1998H25.6005V34H34V25.6005ZM24.3278 24.3278H27.1268V15.6723H24.3278V12.8732H15.6723V15.6723H12.8732V24.3278H15.6723V27.1268H24.3278V24.3278ZM14.3995 6.00002H10.1998V4.72729H15.6723V7.52754H24.3278V4.72729H29.8003V6.00002H25.6005V8.80027H14.3995V6.00002ZM25.6005 28.3995H14.3995V25.6005H11.6005V14.3995H14.3995V11.6005H25.6005V14.3995H28.3995V25.6005H25.6005V28.3995Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpVpcIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpVpcIcon,
);
